<div class="row">
  <div class="col-lg-3">
    <p class="mt-3 mb-0 fst-italic">
      @if (numberOfRows > rowsPerPage) {
        Visar rad {{(currentPage*rowsPerPage)-(rowsPerPage-1)}} till {{(currentPage*rowsPerPage) < numberOfRows ? currentPage*rowsPerPage : numberOfRows}} (av {{numberOfRows}})
      }
      @if (numberOfRows <= rowsPerPage) {
        Visar totalt {{numberOfRows}} rader
      }
    </p>
  </div>
  <div class="col-lg-6">
    @if (numberOfRows > rowsPerPage) {
      <ngb-pagination
        [collectionSize]="numberOfRows"
        [page]="currentPage"
        (pageChange)="currentPageChange.emit($event)"
        [pageSize]="rowsPerPage"
        [maxSize]="pagesVisible"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="showFirstLastLink && (pagesVisible < (numberOfRows/rowsPerPage))">
      </ngb-pagination>
    }
  </div>
  <div class="col-lg-3 text-lg-end text-center">
    @if (showRowsPerPageAlt && numberOfRows > rowsPerPageAlts[0]) {
      <div class="rows-per-page">
        <div class="input-group input-group-sm">
          <span class="input-group-text">
            Rader per sida:
          </span>
          <select class="form-control" [ngModel]="rowsPerPage" (ngModelChange)="changedRowsPerPage($event)">
            @for (alt of rowsPerPageAlts; track alt) {
              <option>{{alt}}</option>
            }
          </select>
        </div>
      </div>
    }
  </div>
</div>
